import client from '../lib/client';

export default {
  create(nonce, cb) {
    const body = { payment_method: { nonce } };
    client.request('post', '/payment_methods', true)
      .send(body)
      .end(cb);
  },
  all(cb) {
    client.request('get', '/payment_methods', true)
      .end(cb);
  },
};



// WEBPACK FOOTER //
// ./src/lib/payment_methods.js